<app-page-header
  [title]="showDetail
    ? (mode() === formMode.CREATE ? 'Nuevo artículo de ayuda' : (selected?.title || 'Editar artículo'))
    : 'Documentación de ayuda'"
  [mobileTitle]="showDetail
    ? (mode() === formMode.CREATE ? 'Nuevo' : 'Editar')
    : 'Ayuda'"
  optionsLabel="Opciones"
  optionsIcon="fa fa-cog"
  [hasOptions]="!showDetail"
  [showBack]="showDetail"
  [unifiedOnMobile]="showDetail"
  (back)="closeDetail()">
  <div headerOptions>
    @if (perm.canCurrent('canCreate')) {
      <a class="dropdown-item" (click)="newArticle()">
        <i class="fas fa-plus fa-fw me-2 text-primary"></i> Nuevo artículo
      </a>
    }
  </div>
</app-page-header>

@if (!showDetail) {
  <div class="row">
    <div class="col-12"
         [class.col-md-12]="!appSettings.isMobile()"
         [class.mobile-requests-container]="appSettings.isMobile()">
      <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
        @if (!appSettings.isMobile()) {
          <p class="text-muted small mb-3">
            Un artículo por ruta de menú/URL. El botón <strong>?</strong> junto al título de cada pantalla
            muestra la ayuda correspondiente. En el markdown documentá <em>Roles y acceso</em>; la nota general
            de permisos vive en el artículo de inicio.
          </p>
        }
        <app-help-list (selectEvent)="onSelected($event)">
          @if (perm.canCurrent('canCreate')) {
            <button class="btn btn-primary btn-sm" (click)="newArticle()">
              <i class="fas fa-plus"></i> Nuevo artículo
            </button>
          }
        </app-help-list>
      </div>
    </div>
  </div>
} @else if (appSettings.isMobile()) {
  <div class="mobile-requests-container">
    <div class="mobile-list-shell">
      <div class="help-edit-mobile-body">
        <div class="mobile-cards-scroll px-1">
          <app-help-form
            [helpForm]="helpForm"
            [mode]="mode()"
            [routeOptions]="routeOptions">
            <div helpAttachments>
              <app-help-attachments [articleUuid]="selected?.uuid || null"></app-help-attachments>
            </div>
          </app-help-form>
        </div>
      </div>
    </div>
  </div>

  <app-mobile-footer [visible]="true">
    @if (perm.canCurrent('canCreate') || perm.canCurrent('canUpdate')) {
      <button type="button" class="btn btn-primary btn-sm flex-grow-1"
        (click)="save()" [disabled]="helpForm.invalid">
        <i class="fas fa-save me-1"></i>Guardar
      </button>
    }
  </app-mobile-footer>
} @else {
  <app-help-form
    [helpForm]="helpForm"
    [mode]="mode()"
    [routeOptions]="routeOptions">
    <div helpFormActions class="d-flex gap-2">
      @if (perm.canCurrent('canCreate') || perm.canCurrent('canUpdate')) {
        <button type="button" class="btn btn-primary btn-sm" (click)="save()"
          [disabled]="helpForm.invalid">
          <i class="fas fa-save"></i> Guardar
        </button>
      }
    </div>
    <div helpAttachments>
      <app-help-attachments [articleUuid]="selected?.uuid || null"></app-help-attachments>
    </div>
  </app-help-form>
}
